import { gql } from "@apollo/client";

const MUTATE_LOG_PROVIDERS = gql`
	mutation ($uuid: String, $url: String, $region_name: String) {
		logProviders(uuid: $uuid, url: $url, region_name: $region_name)
	}
`;

export default MUTATE_LOG_PROVIDERS;
